import React, { useEffect, useState } from 'react';
import { uploadfiledata, updatedata, formatdate } from "../../util/global";

const PatientFileForm = ({ mode, setmode, fetchdata, patientdata }) => {
  const [activefield, setactivefield] = useState(null); 
  const [suggestions, setsuggestions] = useState([]);
  const [filetype, setfiletype] = useState("prescription");
  
  // Dynamic workspace tracking array mapping text descriptions directly to target File binaries
  const [selectedfiles, setselectedfiles] = useState([]);

  const [formdata, setformdata] = useState({
    name: "",
    phonenumber: "",
    datetime: formatdate(new Date()),
    patientid: null
  });

  useEffect(() => {
    if (mode === "showfileform") {
      setformdata({
        name: "",
        phonenumber: "",
        datetime: formatdate(new Date()),
        patientid: null
      });
      // Clear selections cleanly upon opening the modal frame window container
      setselectedfiles([]);
      setfiletype("prescription");
    }
  }, [mode]);

  if (mode !== "showfileform") return null;

  const handleautocomplete = (field, value, data, key) => {
    setformdata({ ...formdata, [field]: value });

    let dupmap = [];
    let matches = [];
    data.filter(item => {
      if (!item) return;
      let val = item[key];
      let dupval = dupmap[val];
      if (dupval) return false;
      dupmap[val] = val;
      if (item[key].toLowerCase().includes(value.toLowerCase())) {
        matches.push(item[key]);
      }
    });
    setsuggestions(matches);
    setactivefield(field);
  };

  const selectoption = (field, value) => {
    if (field === 'name') {
      const match = patientdata.find(item => item.name.trim() === value);
      setformdata({ 
        ...formdata, 
        name: value, 
        phonenumber: match?.phonenumber || formdata.phonenumber,
        patientid: match?.id || match?._id || null
      });
    } else if (field === "phonenumber") {
      const match = patientdata.find(item => item.phonenumber.trim() === value);
      setformdata({ 
        ...formdata, 
        phonenumber: value,
        name: match?.name || formdata.name,
        patientid: match?.id || match?._id || null
      });
    }
    setactivefield(null);

  };

  // Triggered when multiple files are chosen from the file picker window system hook
  const handlemultifilechange = (e) => {
    const filesArray = Array.from(e.target.files || []);
    
    // Transform selected raw binaries directly into our interactive data state tracker layout grid
    const mappedRows = filesArray.map(file => ({
      name: "", // Left blank for custom text tracking descriptions input by the user
      file: file
    }));

    setselectedfiles(mappedRows);
    $("#modal-body-scroll").animate(
      {scrollTop: 5000 + $('#modal-body-scroll').scrollTop()}, 500
    );
  };

  const deleterow = (index) => {
    setselectedfiles(selectedfiles.filter((_, i) => i !== index));
  };

  const handlerowchange = (index, value) => {
    const newrows = [...selectedfiles];
    newrows[index].name = value;
    setselectedfiles(newrows);
  };

  const handlesubmit = async () => {
    if (!formdata.name || !formdata.phonenumber) {
      return alert("please fill patient details");
    }

    if (selectedfiles.length === 0) {
      return alert("please choose at least one file first");
    }

    let targetpatientid = formdata.patientid;

    if (!targetpatientid) {
      const patientpayload = {
        data: {
          name: formdata.name,
          phonenumber: formdata.phonenumber,
          datatype: "patientdata",
          appname: window.appsetting?.appname
        }
      };
      const newpatientres = await updatedata(patientpayload);
      if (newpatientres && newpatientres[0]?.id) {
        targetpatientid = newpatientres[0].id;
      }
    }

    // Process titles using standard description strings or falling back cleanly to intrinsic names
    const filenames = selectedfiles.map(item => item.name || item.file.name);
    const filebinaries = selectedfiles.map(item => item.file);

    const payload = {
      _adminuserid: window.APPSETTING?.adminuserid,
      _userid: window.APPUSER?.user?.userid,
      appname: window.APPSETTING?.appname,
      _patientid: targetpatientid,
      filetype: filetype,
      datetime: formdata.datetime,
      customfilenames: filenames, 
      files: filebinaries
    };

    const result = await uploadfiledata(payload);
    if (result) {
      alert("upload successful");
      setmode("");
      fetchdata();
    } else {
      alert("upload failed");
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h3>upload files</h3>
          <button className="close-btn" onClick={() => setmode("")}>&times;</button>
        </div>
        <div className="modal-body">
          <div style={{maxHeight:'200px', overflowY:'auto'}} id="modal-body-scroll">
            <div className="form-group" style={{ position: 'relative'}}>
              <label>date</label>
              <input 
                type="text" 
                className="form-input date" 
                value={formdata.datetime} 
                id="datetime"
                onChange={(e) => setformdata({ ...formdata, datetime: e.target.value })}
              />
            </div>

            
            <div className="form-group" style={{  }}>
              <label>phone number</label>
              <input 
                type="text" 
                className="form-input" 
                value={formdata.phonenumber} 
                onChange={(e) => handleautocomplete('phonenumber', e.target.value, patientdata.filter(item => item.name.trim().includes(formdata.name)), 'phonenumber')}
                onFocus={(e) => handleautocomplete('phonenumber', e.target.value, patientdata.filter(item => item.name.trim().includes(formdata.name)), 'phonenumber')}
                onBlur={() => setTimeout(() => setactivefield(null), 200)}
              />
              {activefield === 'phonenumber' && (
                <div className="autocomplete-dropdown">
                  {suggestions.map(s => (
                    <div key={s} onMouseDown={() => selectoption('phonenumber', s)} style={{ padding: '10px', cursor: 'pointer' }}>{s}</div>
                  ))}
                </div>
              )}
            </div>

            <div className="form-group" style={{ position: 'relative' }}>
              <label>patient name</label>
              <input 
                type="text" 
                className="form-input" 
                value={formdata.name}
                onChange={(e) => handleautocomplete('name', e.target.value, patientdata, 'name')}
                onFocus={(e) => handleautocomplete('name', e.target.value, patientdata, 'name')}
                onBlur={() => setTimeout(() => setactivefield(null), 200)}
              />
              {activefield === 'name' && (
                <div  style={{ width: '100%',padding: '10px', backgroundColor:'white', maxHeight: '200px', overflowY: 'auto', position:'absolute', zIndex:'10001' }}>
                  {suggestions.map(s => (
                    <div key={s} onMouseDown={() => selectoption('name', s)} style={{ padding: '10px', cursor: 'pointer' }}>{s}</div>
                  ))}
                </div>
              )}
            </div>

            
            <div className="form-group">
              <label>file type</label>
              <select 
                className="form-input" 
                value={filetype} 
                onChange={(e) => setfiletype(e.target.value)}
              >
                <option value="prescription">prescription</option>
                <option value="intakeform">intake form</option>
              </select>
            </div>

            {/* Unified Multi-File Browser Selector Form Group Input Element */}
            <div className="form-group" style={{ marginTop: '20px' }}>
              <label style={{ fontWeight: 'bold' }}>select files</label>
              <input 
                type="file" 
                className="form-input" 
                multiple 
                onChange={handlemultifilechange}
              />
            </div>

            {/* Table display layout renders contextually when item selections exist */}
            {selectedfiles.length > 0 && (
              <table className="grid" style={{ width: '100%', marginBottom: '20px', marginTop: '15px' }}>
                <thead>
                  <tr>
                    <th style={{ width: '50px' }}></th>
                    <th>description</th>
                    <th>filename</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedfiles.map((row, index) => (
                    <tr key={index}>
                      <td style={{ textAlign: 'center', padding: '5px' }}>
                        <button 
                          onClick={() => deleterow(index)} 
                          style={{ background: 'none', border: 'none', color: '#ff4d4f', cursor: 'pointer', fontWeight: 'bold' }}
                        >
                          x
                        </button>
                      </td>
                      <td style={{ padding: '5px' }}>
                        <input 
                          type="text" 
                          className="form-input" 
                          placeholder="file description" 
                          value={row.name}
                          onChange={(e) => handlerowchange(index, e.target.value)}
                        />
                      </td>
                      <td style={{ padding: '8px', fontSize: '13px', color: '#333' }}>
                        {row.file.name}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
            <div id="scrolldiv"></div>
          </div>
          <button className="btn-blue full-width" onClick={handlesubmit} style={{ marginTop: '10px' }}>
            save file record
          </button>

        </div>
      </div>
    </div>
  );
};

export default PatientFileForm;